export function addCollectionIdToEntity(collectionId, entitySchema) {
  var _entitySchema$fields;
  if (!entitySchema) return;
  (_entitySchema$fields = entitySchema.fields) === null || _entitySchema$fields === void 0 ? void 0 : _entitySchema$fields.forEach(item => {
    item['ds:collectionId'] = collectionId;
  });
}
//# sourceMappingURL=addCollectionIdToEntity.js.map
